<script setup>
const codexUrl = "https://docs.vrumble.io";

definePage({
  name: "Codex",
  meta: {
    layout: "default",
    public: true,
    title: "Codex",
    description: "Read the NEXUS Codex for game docs, guides, and updates.",
  },
});
</script>

<template>
  <StarrySky class="" />

  <div class="tw-page-container tw-min-h-screen tw-relative tw-z-10">
    <v-container>
      <iframe
        :src="codexUrl"
        title="Vrumble Codex"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        class="tw-w-full tw-h-[70vh] md:tw-h-[75vh] tw-border-0 tw-bg-[#0b0f1a]"
      />
    </v-container>
  </div>
</template>
